function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "iconDooerAcademy");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  x: "-3.9%",
  y: "-4.2%",
  width: "107.9%",
  height: "107.1%",
  filterUnits: "objectBoundingBox",
  id: "filter-1"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 0,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 8,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.250980392   0 0 0 0 0.305882353   0 0 0 0 0.349019608  0 0 0 0.1 0",
  type: "matrix",
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "SourceGraphic"
}))));

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-9",
  x: 0,
  y: 0,
  width: 33,
  height: 30
});

var _ref6 = /*#__PURE__*/React.createElement("g", {
  id: "Filled_Icons",
  transform: "translate(20.666667, 10.666667)"
});

var SvgIconDooerAcademy = function SvgIconDooerAcademy(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "30px",
    viewBox: "0 0 33 30",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, /*#__PURE__*/React.createElement("g", {
    id: "Dooer-help-box",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-486.000000, -155.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Message-box-2",
    filter: "url(#filter-1)",
    transform: "translate(40.000000, 150.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(428.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(18.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "content-bookmark-3"
  }, _ref5, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(0.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Filled_Icons",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#999"
    },
    d: "M24,9.12370624 C20.8958823,10.2245201 18.6666667,13.1906697 18.6666667,16.6666667 C18.6666667,17.1212671 18.7047678,17.5671194 18.7779439,18.0012 L14.8968,18.0012 L12.8484,20.0496 C12.6144,20.2836 12.3072,20.4012 12,20.4012 C11.6928,20.4012 11.3856,20.2836 11.1516,20.0496 L9.1032,18.0012 L1.2,18.0012 C0.5364,18.0012 0,17.4636 0,16.8012 L0,1.2012 C0,0.5388 0.5364,0.0012 1.2,0.0012 L9.6,0.0012 C9.9192,0.0012 10.2228,0.1284 10.4484,0.3528 L12,1.9044 L13.5516,0.3528 C13.7772,0.1284 14.0808,0.0012 14.4,0.0012 L15.6,0.0012 L15.6,10.8012 L18,8.4012 L20.4,10.8012 L20.4,0.0012 L22.8,0.0012 C23.4636,0.0012 24,0.5388 24,1.2012 L24,9.12370624 Z M9.6,14.4012 L9.6,13.2012 L2.4,13.2012 L2.4,14.4012 L9.6,14.4012 Z M9.6,10.8012 L9.6,9.6012 L2.4,9.6012 L2.4,10.8012 L9.6,10.8012 Z M9.6,7.2012 L9.6,6.0012 L4.8,6.0012 L4.8,7.2012 L9.6,7.2012 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#999"
    },
    d: "M26.6666667,10.6666667 C23.3582667,10.6666667 20.6666667,13.3588667 20.6666667,16.6666667 C20.6666667,19.9756667 23.3582667,22.6666667 26.6666667,22.6666667 C29.9750667,22.6666667 32.6666667,19.9756667 32.6666667,16.6666667 C32.6666667,13.3588667 29.9750667,10.6666667 26.6666667,10.6666667 Z M26.6666667,20.4166667 C26.2526667,20.4166667 25.9166667,20.0812667 25.9166667,19.6666667 C25.9166667,19.2526667 26.2526667,18.9166667 26.6666667,18.9166667 C27.0806667,18.9166667 27.4166667,19.2526667 27.4166667,19.6666667 C27.4166667,20.0812667 27.0806667,20.4166667 26.6666667,20.4166667 Z M27.2666667,17.7916667 L27.2666667,18.4666667 L26.0666667,18.4666667 L26.0666667,16.6666667 L26.6666667,16.6666667 C27.3290667,16.6666667 27.8666667,16.1284667 27.8666667,15.4666667 C27.8666667,14.8042667 27.3290667,14.2666667 26.6666667,14.2666667 C26.0042667,14.2666667 25.4666667,14.8042667 25.4666667,15.4666667 L24.2666667,15.4666667 C24.2666667,14.1436667 25.3436667,13.0666667 26.6666667,13.0666667 C27.9896667,13.0666667 29.0666667,14.1436667 29.0666667,15.4666667 C29.0666667,16.5832667 28.3004667,17.5240667 27.2666667,17.7916667 Z",
    id: "Shape-Copy"
  })), _ref6))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconDooerAcademy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-dooer-academy.94ca6ec9.svg";
export { ForwardRef as ReactComponent };